import * as React from 'react';
import { useSelector } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { Hero } from '../../components/Hero';
import { FiltersTabsContainer } from '../FiltersTabsContainer';
import { FiltersContainer } from '../FiltersContainer';

export const HeroContainer: React.FC = () => {
  const title = useSelector((state: IApplicationState) => state.mainpage.seoData.h1);
  const isChildrenDayEnabled = useSelector((state: IApplicationState) => state.features.isChildrenDayEnabled);

  return (
    <Hero
      title={title}
      isDobroshriftEnabled={false}
      isChildrenDayEnabled={isChildrenDayEnabled}
      filtersBlock={
        <>
          <FiltersTabsContainer />
          <FiltersContainer />
        </>
      }
    />
  );
};
